import Home from './pages/monitoring/Home';
import Enterprise from './pages/monitoring/Enterprise';
import EnterpriseFactoryOverview from './pages/overview/EnterpriseFactoryOverview';
import EnterpriseDataFlow from './pages/overview/EnterpriseDataFlow';
import Factory from './pages/monitoring/Factory';
import FactoryMachineOverview from './pages/overview/FactoryMachineOverview';
import FactoryDefectHistory from './pages/overview/FactoryDefectHistory';
import RealtimeShotStatus from './pages/monitoring/RealtimeShotStatus';
import Machine from './pages/monitoring/Machine';
import AlarmAnalysis from './pages/monitoring/AlarmAnalysis';
import MachineDataView from './pages/monitoring/MachineDataView';
import EquipmentBoard from './pages/monitoring/EquipmentBoard';
import AIAnalysis from './pages/ai/AIAnalysis';
import AiManagePage from './pages/ai/AiManagePage';
import LabelingPage from './pages/ai/LabelingPage';
import LabelReviewPage from './pages/ai/LabelReviewPage';
import ModelDashboard from './pages/model/ModelDashboard';
import { MODULES_BC_ENABLED } from './config/features';
import ModuleBShotSync from './pages/moduleb/ModuleBShotSync';
import ModuleBFeatures from './pages/moduleb/ModuleBFeatures';
import ModuleBFusion from './pages/moduleb/ModuleBFusion';
import ModuleBJudgment from './pages/moduleb/ModuleBJudgment';
import ModuleCRecommend from './pages/modulec/ModuleCRecommend';
import ModuleCSafeguard from './pages/modulec/ModuleCSafeguard';
import Login from './pages/Login';
import UserListPage from './pages/management/UserListPage';
import UserRegisterPage from './pages/management/UserRegisterPage';
import UserDetailPage from './pages/management/UserDetailPage';
import FactoryListPage from './pages/management/FactoryListPage';
import FactoryRegisterPage from './pages/management/FactoryRegisterPage';
import FactoryDetailPage from './pages/management/FactoryDetailPage';
import EquipmentListPage from './pages/management/EquipmentListPage';
import EquipmentRegisterPage from './pages/management/EquipmentRegisterPage';
import EquipmentDetailPage from './pages/management/EquipmentDetailPage';
import MyPage from './pages/MyPage';
import SystemManagementPage from './pages/system/SystemManagementPage';
import RoleManagementPage from './pages/user/RoleManagementPage';
import RoleRegistrationPage from './pages/user/RoleRegistrationPage';
import NoticeManagementPage from './pages/user/NoticeManagementPage';
import IPManagementPage from './pages/system/IPManagementPage';

// 플랫폼 관리 (슈퍼어드민 전용)
import PlatformLayout from './pages/platform/PlatformLayout';
import CompanyManagementPage from './pages/platform/CompanyManagementPage';
import GlobalUsersPage from './pages/platform/GlobalUsersPage';
import SystemStatusPage from './pages/platform/SystemStatusPage';
import LicenseManagementPage from './pages/platform/LicenseManagementPage';
import CompanyRegisterPage from './pages/platform/CompanyRegisterPage';

import { Routes, Route, Navigate } from 'react-router-dom';
import AdminPage from './pages/admin/AdminPage';
import CompanyRegister from './pages/admin/CompanyRegister';
import CompanyDetail from './pages/admin/CompanyDetail';
import NotFound from './pages/NotFound';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    <Routes>
      {/* 로그인 페이지 - 인증 불필요 */}
      <Route path="/login" element={<Login />} />

      {/* 루트 경로 - 로그인 페이지로 리다이렉트 */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* 보호된 라우트 - 로그인 필요 */}
      <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />

      {/* 전사 모니터링 */}
      <Route path="/enterprise" element={<PrivateRoute requiredPermissions={['enterprise.view']}><Enterprise /></PrivateRoute>} />
      <Route path="/enterprise-factory-overview" element={<PrivateRoute requiredPermissions={['enterprise.view']}><EnterpriseFactoryOverview /></PrivateRoute>} />
      {/* 데이터 수집 흐름 — 데모(목업). 실제 설비와 연결되지 않고 브라우저 시뮬레이터로 동작한다. */}
      <Route path="/enterprise-dataflow" element={<PrivateRoute requiredPermissions={['enterprise.view']}><EnterpriseDataFlow /></PrivateRoute>} />

      {/* 공장 모니터링 */}
      <Route path="/factory" element={<PrivateRoute requiredPermissions={['factory_monitoring.view']}><Factory /></PrivateRoute>} />
      <Route path="/factory-machine-overview" element={<PrivateRoute requiredPermissions={['factory_monitoring.view']}><FactoryMachineOverview /></PrivateRoute>} />
      <Route path="/factory-defect-history" element={<PrivateRoute requiredPermissions={['factory_monitoring.view']}><FactoryDefectHistory /></PrivateRoute>} />
      <Route path="/realtime-shot-status" element={<PrivateRoute requiredPermissions={['factory_monitoring.view']}><RealtimeShotStatus /></PrivateRoute>} />

      {/* 사출기 모니터링 */}
      <Route path="/machine" element={<PrivateRoute requiredPermissions={['machine.view']}><Machine /></PrivateRoute>} />
      <Route path="/alarm-analysis" element={<PrivateRoute requiredPermissions={['machine.view']}><AlarmAnalysis /></PrivateRoute>} />
      <Route path="/machine-data" element={<PrivateRoute requiredPermissions={['machine.view']}><MachineDataView /></PrivateRoute>} />
      <Route path="/equipment-board" element={<PrivateRoute requiredPermissions={['machine.view']}><EquipmentBoard /></PrivateRoute>} />

      {/* AI 분석 */}
      <Route path="/ai-analysis" element={<PrivateRoute requiredPermissions={['ai.view']}><AIAnalysis /></PrivateRoute>} />
      <Route path="/ai-manage" element={<PrivateRoute requiredPermissions={['ai.manage']}><AiManagePage /></PrivateRoute>} />
      <Route path="/label-review" element={<PrivateRoute requiredPermissions={['ai.view']}><LabelReviewPage /></PrivateRoute>} />
      <Route path="/labeling" element={<PrivateRoute requiredPermissions={['system.view']}><LabelingPage /></PrivateRoute>} />

      {/* 모델 성능 대시보드 */}
      <Route path="/model" element={<PrivateRoute><ModelDashboard /></PrivateRoute>} />

      {/* 모듈B/C — 제안서 목업. 현재 미사용 기능이라 배포 빌드에서는 라우트를 등록하지 않는다.
          등록하지 않으면 URL 직접 입력 시 아래 path="*" 의 NotFound 로 떨어진다. */}
      {MODULES_BC_ENABLED && (
        <>
          {/* 모듈B — 3종 멀티모달 융합 불량 판정 */}
          <Route path="/module-b/sync" element={<PrivateRoute><ModuleBShotSync /></PrivateRoute>} />
          <Route path="/module-b/features" element={<PrivateRoute><ModuleBFeatures /></PrivateRoute>} />
          <Route path="/module-b/fusion" element={<PrivateRoute><ModuleBFusion /></PrivateRoute>} />
          <Route path="/module-b/judgment" element={<PrivateRoute><ModuleBJudgment /></PrivateRoute>} />

          {/* 모듈C — 온도 포함 권고~승인(HITL) 자율 품질관리 */}
          <Route path="/module-c/recommend" element={<PrivateRoute><ModuleCRecommend /></PrivateRoute>} />
          <Route path="/module-c/safeguard" element={<PrivateRoute><ModuleCSafeguard /></PrivateRoute>} />
        </>
      )}

      {/* 공장/설비 관리 */}
      <Route path="/factory-list" element={<PrivateRoute requiredPermissions={['factory.view']}><FactoryListPage /></PrivateRoute>} />
      <Route path="/factory/register" element={<PrivateRoute requiredPermissions={['factory.create']}><FactoryRegisterPage /></PrivateRoute>} />
      <Route path="/factory/:factoryId" element={<PrivateRoute requiredPermissions={['factory.view']}><FactoryDetailPage /></PrivateRoute>} />
      <Route path="/equipment-list" element={<PrivateRoute requiredPermissions={['equipment.view']}><EquipmentListPage /></PrivateRoute>} />
      <Route path="/equipment/register" element={<PrivateRoute requiredPermissions={['equipment.create']}><EquipmentRegisterPage /></PrivateRoute>} />
      <Route path="/equipment/:equipmentId" element={<PrivateRoute requiredPermissions={['equipment.view']}><EquipmentDetailPage /></PrivateRoute>} />

      {/* 회원 관리 */}
      <Route path="/user" element={<PrivateRoute requiredPermissions={['user.view']}><UserListPage /></PrivateRoute>} />
      <Route path="/user/register" element={<PrivateRoute requiredPermissions={['user.create']}><UserRegisterPage /></PrivateRoute>} />
      <Route path="/user/:userId" element={<PrivateRoute requiredPermissions={['user.view']}><UserDetailPage /></PrivateRoute>} />
      <Route path="/mypage" element={<PrivateRoute><MyPage /></PrivateRoute>} />
      <Route path="/user-roles" element={<PrivateRoute requiredPermissions={['role.view']}><RoleManagementPage /></PrivateRoute>} />
      <Route path="/role-management" element={<PrivateRoute requiredPermissions={['role.view']}><RoleManagementPage /></PrivateRoute>} />
      <Route path="/role-registration" element={<PrivateRoute requiredPermissions={['role.create']}><RoleRegistrationPage /></PrivateRoute>} />
      <Route path="/notices" element={<PrivateRoute requiredPermissions={['notice.view']}><NoticeManagementPage /></PrivateRoute>} />

      {/* 시스템 관리 */}
      <Route path="/system" element={<PrivateRoute requiredPermissions={['system.view']}><SystemManagementPage /></PrivateRoute>} />
      <Route path="/system/ip" element={<PrivateRoute requiredPermissions={['system.view']}><IPManagementPage /></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute allowedRoles={['ADMIN', 'SUPER_ADMIN']}><AdminPage /></PrivateRoute>} />
      <Route path="/admin/company/register" element={<PrivateRoute allowedRoles={['ADMIN', 'SUPER_ADMIN']}><CompanyRegister /></PrivateRoute>} />
      <Route path="/admin/company/:companyId" element={<PrivateRoute allowedRoles={['ADMIN', 'SUPER_ADMIN']}><CompanyDetail /></PrivateRoute>} />

      {/* 플랫폼 관리 (슈퍼어드민 전용) */}
      <Route path="/platform" element={<PrivateRoute allowedRoles={['SUPER_ADMIN']} requiredPermissions={['platform.view']}><PlatformLayout /></PrivateRoute>}>
        <Route index element={<Navigate to="/platform/companies" replace />} />
        <Route path="companies" element={<CompanyManagementPage />} />
        <Route path="companies/register" element={<CompanyRegisterPage />} />
        <Route path="users" element={<GlobalUsersPage />} />
        <Route path="status" element={<SystemStatusPage />} />
        <Route path="licenses" element={<LicenseManagementPage />} />
      </Route>

      {/* 404 Wildcard Route - Must be last */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
